import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";

import useCustomSelector from "@redux/hooks/useCustomSelector";
import { Button, InputText, Text } from "@pentabd/ui";

import useActionCreator from "../../../../../../redux/hooks/useActionCreator";
import {
  ErrorModal,
  InputTextVertical,
  SuccessModal,
  VerticalInputFormLayout,
} from "@components";

interface ConditionFormInput {
  name: string;
}

export default function ConditionForm() {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<ConditionFormInput>();

  const { createConditionActionHandler } = useActionCreator();

  const onSubmit = (data: ConditionFormInput) => {
    createConditionActionHandler(data);
  };

  const { createSuccess, deleteSuccess, createError, deleteError } =
    useCustomSelector((store) => store.inventory.settingsConditionState);

  const [successSubtitle, setSuccessSubtitle] = useState<string>("");
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);

  const createSuccessAction = () => {
    reset();
    setIsSuccessModalOpen(false);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  useEffect(() => {
    if (createSuccess) {
      setSuccessSubtitle("You have created an inventory settings condition");
      setIsSuccessModalOpen(true);
    }

    if (deleteSuccess) {
      setSuccessSubtitle("You have deleted an inventory settings condition");
      setIsSuccessModalOpen(true);
    }

    if (createError || deleteError) {
      setSuccessSubtitle("");
      setIsErrorModalOpen(true);
    }
  }, [createSuccess, deleteSuccess, createError, deleteError]);

  return (
    <div>
      <VerticalInputFormLayout
        label="INVENTORY_SETTINGS.CONDITION.FORM.HEADER"
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
      >
        <InputTextVertical
          label="INVENTORY_SETTINGS.CONDITION.FORM.FIELDS.CONDITION_NAME"
          register={{
            ...register("name", {
              required: "Condition is required",
            }),
          }}
          error={errors}
          required
          cols={3}
        />
      </VerticalInputFormLayout>

      {/* modals  */}
      {isSuccessModalOpen && (
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={createSuccessAction}
          subtitle={successSubtitle}
        />
      )}

      {isErrorModalOpen && (
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
      )}
    </div>
  );
}
